import * as types from "./actionTypes";

const initialState = {
    listBtnLoading: false,
    saveBtnloading: false,
    ERPUrlData: { Data: {} },
    editData: { Status: false },
    updateMsg: { Status: false },
    deleteMsg: { Status: false },
    postMsg: { Status: false },
    error: null,
    ERPUrlDetailsData: { Data: [] },
    partyDropdownList: [],
    partyDropdownLoading: false,
};

const ERPUrlReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.GET_ERPURL_LIST:
            return { ...state, listBtnLoading: true };
        case types.GET_ERPURL_LIST_SUCCESS:
            return { ...state, listBtnLoading: false, ERPUrlData: action.payload };

        case types.EDIT_ERPURL_ID:
            return { ...state, listBtnLoading: action.payload?.btnId ?? true };
        case types.EDIT_ERPURL_ID_SUCCESS:
            return { ...state, listBtnLoading: false, editData: action.payload };

        case types.SAVE_ERPURL_MASTER:
            return { ...state, saveBtnloading: true };
        case types.SAVE_ERPURL_MASTER_SUCCESS:
            return { ...state, saveBtnloading: false, postMsg: action.payload };

        case types.UPDATE_ERPURL_ID:
            return { ...state, saveBtnloading: true };
        case types.UPDATE_ERPURL_ID_SUCCESS:
            return { ...state, saveBtnloading: false, updateMsg: action.payload };

        case types.DELETE_ERPURL_ID:
            return { ...state, listBtnLoading: action.payload?.btnId ?? true };
        case types.DELETE_ERPURL_ID_SUCCESS:
            return { ...state, listBtnLoading: false, deleteMsg: action.payload };

        case types.GET_ERPURL_DETAILS_BY_MASTER:
            return { ...state, ERPUrlDetailsData: { Data: [] } };
        case types.GET_ERPURL_DETAILS_BY_MASTER_SUCCESS:
            return { ...state, ERPUrlDetailsData: { Data: action.payload || [] } };

        case types.GET_ERPURL_PARTY_DROPDOWN:
            return { ...state, partyDropdownLoading: true };
        case types.GET_ERPURL_PARTY_DROPDOWN_SUCCESS:
            return { ...state, partyDropdownLoading: false, partyDropdownList: action.payload || [] };

        case types.ERPURL_API_ERROR:
            return { ...state, listBtnLoading: false, saveBtnloading: false, error: action.payload };

        default:
            return state;
    }
};

export default ERPUrlReducer;